import { render, staticRenderFns } from "./CurrencyExchangeList.vue?vue&type=template&id=520d1984&scoped=true&"
import script from "./CurrencyExchangeList.vue?vue&type=script&lang=js&"
export * from "./CurrencyExchangeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520d1984",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!E:/CBK/PPC/WMS/v1.23.6/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VBreadcrumbs,VBtn,VCard,VContainer,VDataTable,VFlex,VIcon,VLayout,VSelect})
